import React from 'react'

import IcMap from '../../../../../../assets/images/IcMap'
import IcMapActive from '../../../../../../assets/images/IcMapActive'
import Input from '../../../../../Control/Input'

const iconMap = {
    icon: IcMap,
    iconActive: IcMapActive,
    iconError: IcMapActive,
}

const InputLocation = (valueInput) => {
    return (
        <Input 
            name="address"
            className="input-merchant"
            placeholder="Địa chỉ"
            inputType="TEXT"
            value={valueInput.valueInput}
            onChange={valueInput.onChange}
            iconInput={iconMap}
        />
    )
}

export default InputLocation
